var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function SignIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.9999 21.0014C12.9999 21.5529 12.556 22 11.9999 22C11.4476 22 10.9999 21.5542 10.9999 21.0014V13H6.49991C6.23459 13 5.98015 12.8946 5.7926 12.7069L3.79318 10.7063C3.40285 10.3158 3.40294 9.68276 3.79338 9.29231L5.7928 7.29289C5.98034 7.10536 6.23469 7 6.49991 7H10.9999V2.99865C10.9999 2.44711 11.4438 2 11.9999 2C12.5522 2 12.9999 2.44577 12.9999 2.99865V5H17.5005C17.7657 5 18.0201 5.10536 18.2076 5.29289L20.207 7.29231C20.5975 7.68276 20.5976 8.31577 20.2072 8.70632L18.2078 10.7069C18.0202 10.8946 17.7658 11 17.5005 11H12.9999V21.0014ZM17.0848 9L18.1123 8L17.1064 7H12.9999V9H17.0848ZM10.9999 11V9H6.89395L5.88814 10L6.91559 11H10.9999Z", fill: "" })));
}
export var SignIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: SignIconInner }, props))); };
//# sourceMappingURL=SignIcon.js.map